import { useEffect, useRef, useState } from "react";

import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router";

import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, Grid, InputLabel, MenuItem, Paper, Select, Tab, Tabs } from "@mui/material";

import { DocumentEditorContainerComponent, CustomToolbarItemModel, ToolbarItem, Toolbar } from "@syncfusion/ej2-react-documenteditor";
import { DropDownButton, ItemModel } from "@syncfusion/ej2-react-splitbuttons";

import { TabPanel, TabProps } from "../../../helpers/TabPanel";
import { DefaultDocumentEditor } from "../../../helpers/DefaultDocumentEditor";

import { openSnackbar } from "../../../store/slices/SnackbarSlice";

import { DialogActionsStyle, DialogContentStyle } from "../../../styles/DialogStyle";

import { Layout } from "../../../components/Layout";
import { BoxProcesoTerminado } from "../../../components/BoxProcesoTerminado";
import { BoxProcesoCancelado } from "../../../components/BoxProcesoCancelado";
import { BoxHeaderInformacion } from "../../../components/BoxHeaderInformacion";
import { BoxProcesoNoEncontrado } from "../../../components/BoxProcesoNoEncontrado";
import { BoxInformacionExpediente } from "../../../components/BoxInformacionExpediente";
import { CircularProgressIndicator } from "../../../components/CircularProgressIndicator";

import { ObtenerPlantilla, ObtenerPlantillaDetalle } from "../../../connections/admin/PlantillaConnection";
import { ActualizarEstatus, DetalleCertificacion, GuardarCertificacion } from "../../../connections/tribunal/CertificacionConnection";

import { PlantillaProps, ObtenerPlantillasParams } from "../../../interfaces/admin/PlantillaInterface";
import { CertificacionProps, defaultCertificacion, GuardarCertificacionParams } from "../../../interfaces/tribunal/CertificacionInteface";

DocumentEditorContainerComponent.Inject(Toolbar);

const defaultDocument = DefaultDocumentEditor();

interface ItemModelModif extends ItemModel {
    value?: string;
}

export const ElaborarCertificacionPage = () => {

    const dispatch = useDispatch();

    const { Id } = useParams();

    const navigate = useNavigate();

    const syncfusionEditor = useRef<DocumentEditorContainerComponent | null>( null );
    const contenidoRef = useRef( '' );

    const dropCampos = useRef<DropDownButton>( null );

    const [procesoTerminado, setProcesoTerminado] = useState( false );
    const [procesoCancelado, setProcesoCancelado] = useState( false );
    const [procesoNoEncontrado, setProcesoNoEncontrado] = useState( false );
    const [mensajeFinalizacion, setMensajeFinalizacion] = useState( '' );
    const [mensajeAsignacion, setMensajeAsignacion] = useState( '' );

    const [openConfirmacion, setOpenConfirmacion] = useState( false );

    const [value, setValue] = useState( 0 );

    const [editorReady, setEditorReady] = useState( false );

    const [loading, setLoading] = useState( true );
    const [loadingGuardar, setLoadingGuardar] = useState( false );
    const [loadingFinalizar, setLoadingFinalizar] = useState( false );

    const [plantilla, setPlantilla] = useState( 0 );
    const [plantillaArray, setPlantillaArray] = useState<PlantillaProps[]>( [] );

    const [certificacion, setCertificacion] = useState<CertificacionProps>( defaultCertificacion );

    const Toolbar: ( CustomToolbarItemModel | ToolbarItem )[] = [
        'New',
        'Open',
        'Separator',
        'Undo',
        'Redo',
        'Separator',
        'Image',
        'Table',
        'Separator',
        'Header',
        'Footer',
        'Separator',
        {
            tooltipText: 'Atajos',
            text: 'Atajos',
            id: 'dropItem',
            prefixIcon: "e-icons e-drop-down",
        }
    ];

    // ------------------------------------------------------------------------------------------------------------------------

    const handleChange = (_: React.SyntheticEvent, newValue: number) => {

        if ( value === 0 && newValue !== 0 ) {

            const serialized = syncfusionEditor.current?.documentEditor.serialize() ?? '';

            contenidoRef.current = serialized;
            setEditorReady( false );
        }

        setValue( newValue );
    }

    const Guardar = async () => {

        const params: GuardarCertificacionParams = {
            idCertificacion: Id ?? '',
            idPlantilla: plantilla,
            contenido: syncfusionEditor?.current?.documentEditor.serialize() ?? '',
        }

        return await GuardarCertificacion( params );
    }

    const handleGuardar = async () => {

        setLoadingGuardar( true );

        await Guardar().then( resp => {

            setTimeout(() => {

                const { success, message } = resp;

                if ( success ) {

                    dispatch( openSnackbar({ variant: 'success', message }) );
                    setLoadingGuardar( false );

                }
                else {

                    dispatch( openSnackbar({ variant: 'error', message }) );
                    setLoadingGuardar( false );

                }

            }, 700);

        });

    }

    const handleFinalizar = async () => {

        setLoadingFinalizar( true );

        const { success: successGuardar, message: messageGuardar } = await Guardar();

        if ( !successGuardar ) {

            setTimeout(() => {

                dispatch( openSnackbar({ message: messageGuardar, variant: 'error' }) );
                setLoadingFinalizar( false );

            }, 700);

            return;
        }

        await ActualizarEstatus({ idCertificacion: Id ?? '', idEstatus: 53 }).then( resp => {

            setTimeout(() => {

                const { success, message, asignadoMismoUsuario, usuarioAsignado } = resp;

                    if ( success ) {

                        if ( asignadoMismoUsuario) {

                            navigate(`/tribunal/certificacion/visualizar/${ Id }`);

                        } else {

                            setProcesoTerminado( true );
                            setMensajeAsignacion(`La siguiente actividad se asignó a ${ usuarioAsignado }`);

                        }

                        setLoadingFinalizar( false );

                    }
                    else {

                        dispatch(openSnackbar({ message: message, variant: 'error' }));
                        setLoadingFinalizar( false );

                    }

                    setLoadingFinalizar( false );

            }, 700);

        });

    }

    const handleChangePlantilla = async ( value: number ) => {

        setPlantilla( value );

        await ObtenerPlantillaDetalle( value ).then( resp => {

            const { idPlantilla, contenido } = resp;

            if ( idPlantilla !== 0 ) {

                if (!(/<\/?[a-z][\s\S]*>/.test( contenido ))) {

                    const contentSetValues = reemplaceData( contenido );

                    syncfusionEditor.current?.documentEditor.open( contentSetValues );

                }
                else if (/<\/?[a-z][\s\S]*>/.test( contenido )) {

                    const contenidoParser = contenido.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, '').replace(/&/g, "").replace(/acute;/g, "") ?? "";

                    const contentSetValues = reemplaceData( contenidoParser );

                    syncfusionEditor.current?.documentEditor.open( defaultDocument );

                    syncfusionEditor.current?.documentEditor.editor.insertText( contentSetValues );
                }
                else {
                    syncfusionEditor.current?.documentEditor.open( defaultDocument );
                }

            }

        });

    }

    const reemplaceData = ( contenido: string ) => {

        const { expediente } = certificacion;

        const actores = expediente.actores.join(', ');
        const demandados = expediente.demandados.join(', ');

        const contentSetValues = contenido
            .replaceAll('[Numero_Expediente]', expediente.numeroExpediente)
            .replaceAll('[Numero_Folio]', expediente.numeroFolio)
            .replaceAll('[Actor]', actores)
            .replaceAll('[Demandado]', demandados)
            .replaceAll('[Juez]', expediente.juez)
            .replaceAll('[Secretario]', expediente.secretario)
            .replaceAll('[Secretario_Tramite]', expediente.secretarioTramite)
            .replaceAll('[Secretario_Ejecucion]', expediente.secretarioEjecucion);

        return contentSetValues;
    }

    //--------------------------------------------- funciones para el editor de text --------------------------------------------------

    const handleEditorCreated = () => {
        setEditorReady( true );
    };

    useEffect(() => {

        if ( value === 0 && !loading && editorReady && syncfusionEditor.current ) {

            syncfusionEditor.current.documentEditor.open( contenidoRef.current || DefaultDocumentEditor() );
            syncfusionEditor.current.documentEditorSettings.showRuler = true;
            syncfusionEditor.current.documentEditor.pageOutline = '#D0D0D0';

            dropCampos.current?.appendTo('#dropItem');

        }

    }, [ value, loading, editorReady ]);

    //----------------------------------------------------------------------------------------------------------------------------------

    useEffect(() => {

        setPlantilla( 0 );
        setPlantillaArray( [] );

        async function Obtener() {

            const params: ObtenerPlantillasParams = {
                idAutoridad: 0,
                idTipoAcuerdo: 19,
                idSubTipoAcuerdo: 0,
                idTipoNotificacion: 0,
            };

            await ObtenerPlantilla( params ).then( resp => {
                setPlantillaArray( resp );
            })

        }

        Obtener();

    }, [])

    useEffect(() => {

        setLoading( true );

        async function Obtener() {

            await DetalleCertificacion( Id ?? '' ).then( resp => {

                setTimeout(() => {

                    const { success } = resp;

                    if ( success ) {

                        setCertificacion( resp );
                        setPlantilla( resp.idPlantilla );

                        contenidoRef.current = resp.contenido;

                        const { expediente } = resp;

                        const actores = expediente.actores.join(', ');
                        const demandados = expediente.demandados.join(', ');

                        const mkItem = (text: string, id: string, value: string): ItemModelModif[] =>
                            [{ text, id, iconCss: 'e-icons e-bookmark', value }, { separator: true }];

                        let items: ItemModelModif[] = [
                            ...mkItem('Fecha Actual', '1', '[Fecha_Actual]'),
                            ...mkItem('Número de Expediente', '2', expediente.numeroExpediente),
                        ];

                        if ( expediente.numeroFolio ) items.push(...mkItem('Número de Folio', '3', expediente.numeroFolio));
                        if ( actores ) items.push(...mkItem('Actor(es)', '4', actores));
                        if ( demandados ) items.push(...mkItem('Demandado(s)', '5', demandados));
                        if ( expediente.juez ) items.push(...mkItem('Juez', '6', expediente.juez));
                        if ( expediente.secretario ) items.push(...mkItem('Secretario(a) de admisibilidad', '7', expediente.secretario));
                        if ( expediente.secretarioTramite ) items.push(...mkItem('Secretario(a) de Tramite', '8', expediente.secretarioTramite));
                        if ( expediente.secretarioEjecucion ) items.push(...mkItem('Secretario(a) de Ejecucion', '9', expediente.secretarioEjecucion));

                        if ( items[items.length - 1]?.separator ) { items.pop(); }

                        dropCampos.current = new DropDownButton({
                            items: items,
                            beforeItemRender: (data: ItemModelModif) => {
                                return `<div>
                                            <span class="e-menu-icon ${data.iconCss}"></span>
                                            <span class="custom-class" >${data.text}</span>
                                        </div>`;
                            },
                            select: (args) => syncfusionEditor.current?.documentEditor.editor.insertText(args?.item.value ?? ""),
                        },);

                        if ( resp.idEstatus === 3 ) {
                            setMensajeFinalizacion('No se tienen actividades pendientes para este trámite');
                            setProcesoTerminado( true );
                            setLoading( false );
                        }
                        else if ( resp.idEstatus === 4 ) {
                            setProcesoCancelado( true );
                            setLoading( false );
                        }
                        else if ( !resp.usuarioActualAsignacion ) {
                            setMensajeAsignacion(`La siguiente actividad se asignó a: ${ resp.usuarioAsignacion }`);
                            setProcesoTerminado( true );
                            setLoading( false );
                        }
                        else if ( resp.usuarioActualAsignacion && resp.idEstatus !== 52 ) {
                            setMensajeAsignacion('La siguiente actividad se encuentra en tu bandeja');
                            setProcesoTerminado( true );
                            setLoading( false );
                        }
                        else if ( resp.usuarioActualAsignacion && resp.idEstatus === 52 ) {
                            setLoading( false );
                        }

                    }
                    else {

                        setProcesoNoEncontrado( true );
                        setLoading( false );

                    }

                }, 700);

            });

        }

        if ( Id ) {
            Obtener();
        }

    }, [ Id ])

    return (
        <Layout breadcrumbs={[{ text: 'Tribunal' }, { text: 'Certificación' }, { text: 'Elaborar certificación' }]} backgroundPaper={ ( procesoTerminado || procesoNoEncontrado ) }>

            {
                loading
                ?
                    <Box component={ Paper } height={ '70vh' } textAlign={ 'center' } alignContent={ 'center' } alignItems={ 'center' }>
                        <CircularProgressIndicator />
                    </Box>
                :
                    ( procesoTerminado || procesoCancelado || procesoNoEncontrado )
                    ?
                        procesoNoEncontrado
                        ?
                            <BoxProcesoNoEncontrado />
                        :
                            procesoCancelado
                            ?
                                <BoxProcesoCancelado />
                            :
                                <BoxProcesoTerminado message={ mensajeFinalizacion } messageAssing={ mensajeAsignacion } processEnd={ certificacion.idEstatus === 3 } />
                        :
                            <>

                                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>

                                    <Tabs value={ value } onChange={ handleChange }>
                                        <Tab label="Certificación" {...TabProps( 0 )} />
                                        <Tab label="Información del expediente" {...TabProps(1)} />
                                    </Tabs>

                                </Box>

                                <TabPanel value={ value } index={ 0 }>

                                    <Box sx={{ display: value === 0 ? 'block' : 'none' }}>

                                        <Box p={ 4 } component={ Paper }>

                                            <BoxHeaderInformacion
                                                numeroSeguimiento={ `GEC-${ certificacion.idCertificacion }` }
                                                fecha={ certificacion.fecha ?? new Date() }
                                                juez={ certificacion.expediente.juez }
                                            />

                                            <Grid container spacing={ 3 } mt={ 3 }>

                                                <Grid size={{ md: 12, xs: 12 }}>

                                                    <FormControl fullWidth>
                                                        <InputLabel>Plantilla</InputLabel>

                                                        <Select
                                                            label="Plantilla"
                                                            value={ plantilla }
                                                            onChange={ (e) => handleChangePlantilla( e.target.value ) }
                                                        >
                                                            <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>
                                                            {
                                                                plantillaArray.map(({ idPlantilla, descripcion }) => (
                                                                    <MenuItem key={ idPlantilla } value={ idPlantilla }>{ descripcion }</MenuItem>
                                                                ))
                                                            }
                                                        </Select>
                                                    </FormControl>

                                                </Grid>

                                                <Grid size={{ md: 12, xs: 12 }}>

                                                    <DocumentEditorContainerComponent
                                                        key='DocumentEditorContainer'
                                                        serviceUrl={ process.env.REACT_APP_URL_SERVICE_DOCUMENT_EDITOR ?? '' }
                                                        height='650'
                                                        ref={ syncfusionEditor }
                                                        enableToolbar={ true }
                                                        showPropertiesPane={ false }
                                                        toolbarItems={ Toolbar }
                                                        autoResizeOnVisibilityChange={ false }
                                                        created={ handleEditorCreated }
                                                    >
                                                    </DocumentEditorContainerComponent>

                                                </Grid>

                                                <Grid size={{ md: 12, xs: 12 }} sx={{ mt: 3 }}>

                                                    <Grid container spacing={ 3 }>

                                                        <Grid size={{ md: 6, xs: 12 }} sx={{ textAlign: 'right' }}>

                                                            <Button
                                                                fullWidth
                                                                color='secondary'
                                                                variant="outlined"
                                                                loading={ loadingGuardar }
                                                                onClick={ handleGuardar }
                                                            >
                                                                Guardar
                                                            </Button>

                                                        </Grid>

                                                        <Grid size={{ md: 6, xs: 12 }} style={{ textAlign: 'left' }}>

                                                            <Button
                                                                fullWidth
                                                                color='primary'
                                                                variant="contained"
                                                                onClick={ () => setOpenConfirmacion( true ) }
                                                            >
                                                                Finalizar
                                                            </Button>

                                                        </Grid>

                                                    </Grid>

                                                </Grid>

                                            </Grid>

                                        </Box>

                                    </Box>

                                </TabPanel>

                                <TabPanel value={ value } index={ 1 }>

                                    <BoxInformacionExpediente expediente={ certificacion.expediente } />

                                </TabPanel>

                                <Dialog
                                    fullWidth
                                    maxWidth='xs'
                                    open={ openConfirmacion }
                                    onClose={ () => {} }
                                >

                                    <DialogTitle>
                                        Confirmación
                                    </DialogTitle>

                                    <DialogContent sx={ DialogContentStyle }>

                                        <DialogContentText>
                                            ¿Desea finalizar la elaboración de la certificación?
                                        </DialogContentText>

                                    </DialogContent>

                                    <DialogActions sx={ DialogActionsStyle }>
                                        <Button color="secondary" disabled={ loadingFinalizar } onClick={ () => setOpenConfirmacion( false ) }> Cancelar </Button>
                                        <Button loading={ loadingFinalizar } onClick={ handleFinalizar } variant='contained' > Aceptar </Button>
                                    </DialogActions>

                                </Dialog>

                            </>
            }

        </Layout>
    )
}
